export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12605.f945854f.jpg";